import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/auth";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Card } from "primereact/card";

const cardData = [
  {
    imgSrc: "/images/landing-page/hesaplama.jpg",
    title: "Hesaplama",
    description: "Yeşil dönüşüm ve sürdürülebilirlik politikalarınızı planlamak için gerekli hesaplamalar",
    path: "/app/karbonayakizi",
    icon: "pi pi-calculator",
    color: "bg-blue-100",
    textColor: "text-blue-700"
  },
  {
    imgSrc: "/images/landing-page/rapor.jpg",
    title: "Raporlama",
    description: "Sürdürülebilirlik, çevresel performans, iyileştirme ve malzeme-kaynak yönetimi raporları",
    path: "/app/rapor",
    icon: "pi pi-file-pdf",
    color: "bg-green-100",
    textColor: "text-green-700"
  },
  {
    imgSrc: "/images/landing-page/analiz.jpg",
    title: "Analiz",
    description:
      "Yeşil dönüşüm olgunluk analizi, dijital dönüşüm endeksi ve sektör/bölge/ülke genelindeki istatistikler ve raporlar",
    path: "/app/grafik",
    icon: "pi pi-chart-line",
    color: "bg-purple-100",
    textColor: "text-purple-700"
  },
  {
    imgSrc: "/images/landing-page/egitim.jpg",
    title: "Eğitim",
    description: "Sürdürülebilirlik, yenilikçilik, teknoloji, kurumsal gelişim ve iklim değişikliğine uyum eğitimleri",
    path: "/app/egitim",
    icon: "pi pi-book",
    color: "bg-orange-100",
    textColor: "text-orange-700"
  },
  {
    imgSrc: "/images/landing-page/afad.jpg",
    title: "İş Sürekliliği Planı",
    description:
      "Afet durumunda sanayi kuruluşlarının faaliyet göstermesi için AFAD ve Sanayi Bakanlığı ile geliştirdiğimiz iş birliği çalışmaları",
    path: "/app/is-surekliligi",
    icon: "pi pi-sync",
    color: "bg-red-100",
    textColor: "text-red-700"
  },
  {
    imgSrc: "/images/landing-page/haber.jpg",
    title: "OSBÜK Bülten",
    description: "Türkiye'deki organize sanayi bölgeleriyle ilgili güncel haberler, projeler ve sektörel gelişmeler",
    path: "/app/bulten",
    icon: "pi pi-envelope",
    color: "bg-cyan-100",
    textColor: "text-cyan-700"
  }
];

function Homepage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [visible, setVisible] = useState<boolean>(false);

  const handleClick = (path: string) => {
    if (path.endsWith(".pdf")) {
      window.open(path, "_blank");
    } else {
      navigate(path);
    }
  };

  useEffect(() => {
    if (auth.getUser().firstName === null || auth.getUser().lastName === null) {
      setVisible(true);
    }
  }, [auth.getUser()]);

  return (
    <>
      <Dialog
        header="Profil Bilgileri"
        visible={visible}
        style={{ width: "50vw", textAlign: "center" }}
        onHide={() => {
          if (!visible) return;
          setVisible(false);
        }}
      >
        <p className="m-0">
          Hesabınızla ilgili bazı bilgilerin eksik olduğu tespit edildi. Lütfen eksik bilgilerinizi profilim sayfasından
          doldurun.
        </p>
        <Button
          label="Profil Sayfasına Git"
          onClick={() => navigate("/app/profile")}
          style={{ display: "block", margin: "20px auto" }}
        />
      </Dialog>

      <div className="surface-0">
        {/* Hero Section */}
        <div 
          className="py-6 px-4 lg:px-8 relative overflow-hidden"
          style={{
            background: "linear-gradient(135deg, #114d6b 0%, #1e6b8a 100%)",
            borderRadius: "0 0 2rem 2rem"
          }}
        >
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -mr-16 -mt-16"></div>
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full -ml-12 -mb-12"></div>
          </div>
          
          <div className="relative z-10 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold text-white mb-3">
              Hoş Geldiniz, {auth.getUser().firstName} {auth.getUser().lastName}
            </h1>
            <p className="text-xl text-blue-100 mb-4 max-w-3xl mx-auto">
              Yeşil dönüşüm ve sürdürülebilirlik yolculuğunuzda size rehberlik etmekten mutluluk duyuyoruz.
            </p>
          </div>
        </div>

        {/* Topluluk ve Destek */}
        <div className="py-6 px-4 lg:px-8 bg-gray-50">
          <div className="text-center mb-5">
            <h2 className="text-3xl font-bold text-900 mb-2">Topluluk ve Destek</h2>
            <p className="text-600 text-lg">İletişim ve bilgi paylaşım platformları</p>
          </div>
          
          <div className="grid justify-content-center">
            <div className="col-12 md:col-4">
              <Card className="text-center h-full cursor-pointer hover:shadow-lg transition-all duration-300" onClick={() => navigate("/app/forum-homepage")}>
                <div className="bg-cyan-100 w-6rem h-6rem rounded-full flex align-items-center justify-content-center mx-auto mb-3">
                  <i className="pi pi-comments text-3xl text-cyan-700"></i>
                </div>
                <h3 className="text-xl font-bold text-900 mb-2">Forum</h3>
                <p className="text-600 mb-3">OSB'ler arası iletişim ve bilgi paylaşım platformu</p>
                <Button 
                  label="Foruma Git" 
                  icon="pi pi-arrow-right" 
                  className="p-button-outlined p-button-cyan"
                />
              </Card>
            </div>
            
            <div className="col-12 md:col-4">
              <Card className="text-center h-full cursor-pointer hover:shadow-lg transition-all duration-300" onClick={() => navigate("/app/stratejik-plan")}>
                <div className="bg-blue-100 w-6rem h-6rem rounded-full flex align-items-center justify-content-center mx-auto mb-3">
                  <i className="pi pi-compass text-3xl text-blue-700"></i>
                </div>
                <h3 className="text-xl font-bold text-900 mb-2">Stratejik Plan</h3>
                <p className="text-600 mb-3">Stratejik planlama süreci ve uygulama yöntemleri</p>
                <Button 
                  label="Plan Çalışması" 
                  icon="pi pi-arrow-right" 
                  className="p-button-outlined p-button-blue"
                />
              </Card>
            </div>
            
            <div className="col-12 md:col-4">
              <Card className="text-center h-full cursor-pointer hover:shadow-lg transition-all duration-300" onClick={() => navigate("/app/yapay-zeka")}>
                <div className="bg-purple-100 w-6rem h-6rem rounded-full flex align-items-center justify-content-center mx-auto mb-3">
                  <i className="pi pi-comment text-3xl text-purple-700"></i>
                </div>
                <h3 className="text-xl font-bold text-900 mb-2">Yapay Zeka Sohbeti</h3>
                <p className="text-600 mb-3">OSBÜK hakkında bilgi alın ve sorularınızı sorun</p>
                <Button 
                  label="Sohbete Başla" 
                  icon="pi pi-arrow-right" 
                  className="p-button-outlined p-button-purple"
                />
              </Card>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="py-6 px-4 lg:px-8">
          <div className="text-center mb-5">
            <h2 className="text-3xl font-bold text-900 mb-2">Hızlı Erişim</h2>
            <p className="text-600 text-lg">İhtiyacınız olan hizmetlere hızlıca ulaşın</p>
          </div>
          
          <div className="grid">
            {cardData.map((card, index) => (
              <div className="col-12 md:col-6 lg:col-4" key={index}>
                <Card 
                  className="h-full cursor-pointer hover:shadow-lg transition-all duration-300" 
                  onClick={() => handleClick(card.path)}
                >
                  <div className="flex align-items-center">
                    <div className={`${card.color} w-4rem h-4rem rounded-lg flex align-items-center justify-content-center mr-3`}>
                      <i className={`${card.icon} text-2xl ${card.textColor}`}></i>
                    </div>
                    <div className="flex-1">
                      <h5 className="mb-1 text-900">{card.title}</h5>
                      <p className="text-600 text-sm line-height-2">{card.description}</p>
                    </div>
                  </div>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Homepage;
